var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 519,
    height: 956,
    viewBox: "0 0 519 956",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2905_17717)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 45,
    width: 375,
    height: 812,
    rx: 30,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_2905_17717)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 66,
    transform: "translate(72 45)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 97C88 91.4772 92.4772 87 98 87H421C426.523 87 431 91.4772 431 97V97H88V97Z",
    fill: "black",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M447 45H72V111C72 107.277 72 105.416 72.4894 103.91C73.4786 100.865 75.8655 98.4786 78.9098 97.4894C80.4162 97 82.2774 97 86 97H88C88 91.4772 92.4772 87 98 87H421C426.523 87 431 91.4772 431 97H433C436.723 97 438.584 97 440.09 97.4894C443.135 98.4786 445.521 100.865 446.511 103.91C447 105.416 447 107.277 447 111V45Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M395.33 64.6084C397.546 64.6085 399.677 65.4599 401.283 66.9867C401.404 67.1046 401.597 67.1031 401.716 66.9834L402.872 65.8167C402.933 65.756 402.966 65.6737 402.966 65.5882C402.965 65.5026 402.931 65.4207 402.87 65.3607C398.655 61.3212 392.005 61.3212 387.79 65.3607C387.729 65.4207 387.694 65.5025 387.693 65.5881C387.693 65.6737 387.726 65.7559 387.787 65.8167L388.943 66.9834C389.062 67.1033 389.255 67.1048 389.376 66.9867C390.982 65.4598 393.114 64.6084 395.33 64.6084V64.6084ZM395.33 68.404C396.547 68.404 397.721 68.8565 398.624 69.6737C398.746 69.7897 398.938 69.7872 399.057 69.668L400.212 68.5014C400.273 68.4402 400.307 68.3572 400.306 68.2709C400.305 68.1846 400.269 68.1023 400.207 68.0424C397.459 65.486 393.203 65.486 390.455 68.0424C390.393 68.1023 390.357 68.1847 390.357 68.271C390.356 68.3573 390.39 68.4403 390.451 68.5014L391.605 69.668C391.724 69.7872 391.916 69.7897 392.038 69.6737C392.94 68.857 394.113 68.4046 395.33 68.404V68.404ZM397.549 71.1884C397.611 71.1278 397.645 71.0444 397.643 70.9579C397.641 70.8714 397.604 70.7894 397.54 70.7314C396.264 69.6525 394.396 69.6525 393.12 70.7314C393.056 70.7894 393.019 70.8713 393.017 70.9578C393.015 71.0443 393.049 71.1277 393.111 71.1884L395.108 73.204C395.167 73.2633 395.247 73.2966 395.33 73.2966C395.413 73.2966 395.493 73.2633 395.552 73.204L397.549 71.1884Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.667 69.3337H367.667C368.219 69.3337 368.667 69.7814 368.667 70.3337V72.3337C368.667 72.8859 368.219 73.3337 367.667 73.3337H366.667C366.115 73.3337 365.667 72.8859 365.667 72.3337V70.3337C365.667 69.7814 366.115 69.3337 366.667 69.3337V69.3337ZM371.334 67.3337H372.334C372.886 67.3337 373.334 67.7814 373.334 68.3337V72.3337C373.334 72.8859 372.886 73.3337 372.334 73.3337H371.334C370.781 73.3337 370.334 72.8859 370.334 72.3337V68.3337C370.334 67.7814 370.781 67.3337 371.334 67.3337ZM376 65.0003H377C377.553 65.0003 378 65.448 378 66.0003V72.3337C378 72.8859 377.553 73.3337 377 73.3337H376C375.448 73.3337 375 72.8859 375 72.3337V66.0003C375 65.448 375.448 65.0003 376 65.0003ZM380.667 62.667H381.667C382.219 62.667 382.667 63.1147 382.667 63.667V72.3337C382.667 72.8859 382.219 73.3337 381.667 73.3337H380.667C380.115 73.3337 379.667 72.8859 379.667 72.3337V63.667C379.667 63.1147 380.115 62.667 380.667 62.667V62.667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2905_17717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.134 73.2563C107.2 73.2563 105.721 72.1211 105.413 70.3926H107.296C107.523 71.1836 108.248 71.6743 109.156 71.6743C110.701 71.6743 111.588 70.2607 111.61 67.8145H111.485C110.987 68.8179 109.984 69.3892 108.746 69.3892C106.732 69.3892 105.267 67.9097 105.267 65.8809C105.267 63.7129 106.893 62.1675 109.193 62.1675C111.72 62.1675 113.419 64.1011 113.419 67.5947C113.419 71.1543 111.822 73.2563 109.134 73.2563ZM109.2 67.895C110.423 67.895 111.295 67.0381 111.295 65.8589C111.295 64.6577 110.401 63.7422 109.207 63.7422C108.013 63.7422 107.12 64.6431 107.12 65.8223C107.12 67.0454 107.97 67.895 109.2 67.895ZM116.437 71.5425C115.748 71.5425 115.265 71.0444 115.265 70.3853C115.265 69.7188 115.748 69.228 116.437 69.228C117.132 69.228 117.608 69.7188 117.608 70.3853C117.608 71.0444 117.132 71.5425 116.437 71.5425ZM116.437 66.1958C115.748 66.1958 115.265 65.7051 115.265 65.0459C115.265 64.3794 115.748 63.8887 116.437 63.8887C117.132 63.8887 117.608 64.3794 117.608 65.0459C117.608 65.7051 117.132 66.1958 116.437 66.1958ZM124.611 73V70.9858H119.447V69.4111C120.817 67.0234 122.318 64.6138 123.754 62.4312H126.42V69.3892H127.848V70.9858H126.42V73H124.611ZM121.198 69.3306V69.4331H124.64V63.9692H124.537C123.454 65.6099 122.23 67.5508 121.198 69.3306ZM131.877 73V64.3354H131.752L129.123 66.1812V64.3647L131.884 62.4312H133.766V73H131.877Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M407 66C407 63.7909 408.791 62 411 62H428C430.209 62 432 63.7909 432 66V71C432 73.2091 430.209 75 428 75H411C408.791 75 407 73.2091 407 71V66Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433 67V71.2203C433.849 70.8629 434.401 70.0314 434.401 69.1102C434.401 68.1889 433.849 67.3574 433 67",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.443 72V66.3896H412.355L410.627 67.5811V66.209L412.448 64.9541H413.918V72H412.443ZM418.646 72.1807C416.902 72.1807 415.848 70.8037 415.848 68.4648C415.848 66.1309 416.912 64.7734 418.646 64.7734C420.374 64.7734 421.443 66.1309 421.443 68.4697C421.443 70.7988 420.389 72.1807 418.646 72.1807ZM418.646 70.9795C419.456 70.9795 419.949 70.1348 419.949 68.4648C419.949 66.8047 419.451 65.9795 418.646 65.9795C417.845 65.9795 417.342 66.8096 417.342 68.4648C417.342 70.1348 417.84 70.9795 418.646 70.9795ZM425.551 72.1807C423.808 72.1807 422.753 70.8037 422.753 68.4648C422.753 66.1309 423.818 64.7734 425.551 64.7734C427.28 64.7734 428.349 66.1309 428.349 68.4697C428.349 70.7988 427.294 72.1807 425.551 72.1807ZM425.551 70.9795C426.362 70.9795 426.855 70.1348 426.855 68.4648C426.855 66.8047 426.357 65.9795 425.551 65.9795C424.75 65.9795 424.247 66.8096 424.247 68.4648C424.247 70.1348 424.746 70.9795 425.551 70.9795Z",
    fill: "#1E2632"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2905_17717",
    x: 0,
    y: 0,
    width: 519,
    height: 956,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 27
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 36
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.104062 0 0 0 0 0.106875 0 0 0 0 0.1125 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2905_17717"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2905_17717",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_2905_17717",
    x: 52,
    y: 25,
    width: 415,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2905_17717"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2905_17717",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2905_17717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 18,
    fill: "white",
    transform: "translate(93 59)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqPreview);
export default __webpack_public_path__ + "static/media/faqPreview.da1e5e3fdee482cded3bf3f36affd86f.svg";
export { ForwardRef as ReactComponent };